import { ROLE, RoleType } from 'src/models/User'

export const isPaidMember = (
  paid: boolean | undefined,
  role: RoleType | undefined | '',
) => {
  return paid && role != ROLE.FREE_TRIAL
}

export const isDisplayPaidPlanTab = (free: boolean, role: RoleType | '') => {
  return free || role == ROLE.FREE_TRIAL
}

const checkPaidPlan = (role: RoleType | undefined | '') => {
  if (role == undefined || role == '') return false

  switch (role) {
    case ROLE.FREE:
    case ROLE.RECESS:
    case ROLE.FREE_TRIAL:
    case ROLE.PARTNER:
      return false
    default:
      return true
  }
}

export const shouldDisplayPaidPlanLabel = (
  roles: (RoleType | undefined | '')[],
) => {
  return roles.every((role) => checkPaidPlan(role))
}

export const getPlanNameAndMaxTags = (role: string) => {
  switch (role) {
    case ROLE.PREMIUM:
      return { _planName: 'プレミアム', _maxTags: 9999 }
    case ROLE.ONLYSTORY_REFERRER:
      return { _planName: '紹介担当', _maxTags: 9999 }
    case ROLE.STANDARD:
      return { _planName: 'スタンダード', _maxTags: 5 }
    case ROLE.LIGHT:
    case ROLE.FREE_TRIAL:
      return { _planName: 'ライト', _maxTags: 3 }
    case ROLE.LIGHT_OTHER:
      return { _planName: 'その他ライト', _maxTags: 3 }
    default:
      return { _planName: '現在の', _maxTags: 3 }
  }
}
